import { makeStyles } from '@material-ui/core/styles'
import { rgba } from 'polished'
import { VIDEO_VISIT_REARRANGEMENT, DASHBOARD_CARDS_SIZE_CHANGE } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  defaultImageContainer: {
    height: '100%',
    display: 'inline-flex',
    flex: '0 1 auto',
    alignItems: 'center',
    padding: `${theme.spacing(3.75)}px ${theme.spacing(2)}px`,
    background: rgba(theme.palette.tertiary.lightGreen, 0.1),
    [theme.breakpoints.down(DASHBOARD_CARDS_SIZE_CHANGE)]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1),
    },
    [theme.breakpoints.down(VIDEO_VISIT_REARRANGEMENT)]: {
      padding: `${theme.spacing(0.7)}px`,
      display: 'flex',
      justifyContent: 'center',
    },
  },
  arrow: {
    position: 'absolute',
    cursor: 'pointer',
    // TODO: cleaner vertical center
    top: 13,
    right: 11,
    '&&': {
      margin: 0,
      fill: theme.palette.tertiary.darkGreen,
      maxWidth: '1.3em',
    },
  },
  openedArrow: {
    transform: 'rotate(180deg)',
  },
}))

export default useStyles
